export default "__VITE_ASSET__B2Twd$Dr__"